<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      :class="{'side-drawer__overlay': !hideOverlay}"
      data-pendo-ds="side_drawer"
      @click.self="clickAway"
    />
    <div
      class="side-drawer"
      :data-testid="dataTestid"
      @mouseenter="$emit('hovering', true)"
      @mouseleave="$emit('hovering', false)"
      @touchend="$emit('hovering', false)"
      @touchstart="$emit('hovering', true)"
    >
      <transition :name="`slide-fade-${xPosition}`">
        <SideDrawerContent
          v-if="isOpen"
          :allow-body-scroll="allowBodyScroll"
          :floating="floating"
          :show-close-button="showCloseButton"
          :title="title"
          :width="width"
          :x-position="xPosition"
          :y-position="yPosition"
          @close="closeSideDrawer"
        >
          <template
            v-for="(_, name) in $slots"
            #[name]
          >
            <slot :name="name" />
          </template>
        </SideDrawerContent>
      </transition>
    </div>
  </Teleport>
</template>

<script>
  import SideDrawerContent from './SideDrawerContent.vue'

  export default {
  name: 'SideDrawer',
  components: {
    SideDrawerContent,
  },
  props: {
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    isOpen:{
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: '600px',
    },
    dataTestid: {
      type: String,
      default: 'side-drawer',
    },
    floating: {
      type: Boolean,
      default: false,
    },
    xPosition: {
      type: String,
      default: 'right',
      validator: (value) => ['right', 'left'].includes(value),
    },
    yPosition: {
      type: String,
      default: null,
      validator: (value) => ['top', 'bottom'].includes(value),
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    allowBodyScroll: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'hovering'],
  methods: {
    closeSideDrawer() {
      this.$emit('close')
    },
    clickAway() {
      this.closeSideDrawer()
    },
  },
}
</script>

<style scoped lang="scss">
.slide-fade-right-enter-active,
.slide-fade-right-leave-active,
.slide-fade-left-enter-active,
.slide-fade-left-leave-active {
  transition: all .4s ease-in-out;
}

.slide-fade-right-enter-from,
.slide-fade-right-leave-to,
.slide-fade-left-enter-from,
.slide-fade-left-leave-to {
  opacity: 1;
  transform: translateY(100%)
}

.slide-fade-right-enter-from,
.slide-fade-right-leave-to {
  @media (min-width: 768px) {
    transform: translateX(100%);
  }
}

.slide-fade-left-enter-from,
.slide-fade-left-leave-to {
  @media (min-width: 768px) {
    transform: translateX(-100%);
  }
}

.side-drawer {
  display: flex;
  position: relative;
  z-index: 1300;
}

.side-drawer__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1200;
  padding: var(--space-10);
  backdrop-filter: brightness(80%);
  background: rgba(0, 0, 0, 0.25);
}
</style>
